// extracted by mini-css-extract-plugin
export default {"planetList__container":"PlanetList_planetList__container__by2de"};